<div class="SecureImage">
	<img
		*ngIf="imageSrc"
		[src]="imageSrc"
		[alt]="alt"
		[class]="className"
		(load)="onNativeLoad()"
		(error)="onNativeError($event)"
	/>

	<ng-container *ngIf="!imageSrc">
		<div class="SecureImage__placeholder" *ngIf="loading">
			Cargando imagen… <span *ngIf="lastRequestUrl">(request: {{ lastRequestUrl }})</span>
		</div>
		<div class="SecureImage__placeholder" *ngIf="!loading">No hay imagen disponible</div>
	</ng-container>
</div>
